import {
  
    GET_YEAR_SCIENTIFIC_WORK_STARTED,
    GET_YEAR_SCIENTIFIC_WORK_COMPLETED,
    GET_TYPEOF_SCIENTIFIC_WORK_STARTED,
    GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED,
    SCIENTIFIC_WORK_FETCH_STARTED,
    SCIENTIFIC_WORK_FETCH_COMPLETED,
    SCIENTIFIC_WORK_FETCH_FAILED,
    SET_SCIENTIFIC_WORK_COUNT,
  } from '../actions/types';
  
  const initialState = {
    scientificWorkYear : [],
    scientificWorkTypeof: [],
    scientificWorkList: [],
    isLoading: false,
    isError: false,
    pagesCount:0,
  }
  export default function scientificWork(state = initialState, action) {
  
    switch (action.type) {
  
      case GET_YEAR_SCIENTIFIC_WORK_COMPLETED:
        return {
          ...state,
          scientificWorkYear:action.scientificWorkYear
         };
  
      case GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED:
        return {
          ...state,
          scientificWorkTypeof:action.scientificWorkTypeof
        };
        case SCIENTIFIC_WORK_FETCH_STARTED:
          return {
            ...state,
            isLoading: true,
            isError: false,
          };
 
      case SCIENTIFIC_WORK_FETCH_COMPLETED:
        return {
          ...state,
          scientificWorkList:action.scientificWorkList,
          isLoading: false,
          isError: false,
        };
        case SCIENTIFIC_WORK_FETCH_FAILED:
          return {
            ...state,
            isLoading: false,
            isError: true,
          };
         case SET_SCIENTIFIC_WORK_COUNT:
          return {
            ...state,
            pagesCount: action.data,
             };
 
      default: return state;
    }
  };
  